import { useState } from 'react';
import type { FormEvent } from 'react';
import { useAuth } from '../auth';
import { Logo } from '../components/Logo';
import { ErrorNote } from '../components/ui';
import { useNavigate } from '../router';

export function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = (event: FormEvent) => {
    event.preventDefault();
    setBusy(true);
    setError(null);
    login(email, password)
      .catch((reason: unknown) =>
        setError(reason instanceof Error ? reason.message : String(reason)),
      )
      .finally(() => setBusy(false));
  };

  return (
    <main className="login-shell">
      <form className="login" onSubmit={submit}>
        <Logo id="logo-login" subtitle="Operasyon paneli" />

        <label className="field">
          <span className="field-label">E-posta</span>
          <input
            type="email"
            value={email}
            autoComplete="username"
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </label>
        <label className="field">
          <span className="field-label">Parola</span>
          <input
            type="password"
            value={password}
            autoComplete="current-password"
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </label>
        <ErrorNote message={error} />
        <button type="submit" disabled={busy}>
          {busy ? 'Giriş yapılıyor…' : 'Giriş yap'}
        </button>
        <button type="button" className="linky login-back" onClick={() => navigate('/')}>
          ← Geri
        </button>
      </form>
    </main>
  );
}
